import { Factory } from 'rosie';

Factory.define('SystemConfiguration');

Factory.define('SystemConfigurationWithDefaults').extend('SystemConfiguration').attr('fbAppId', 'some-fb-app-id');



// WEBPACK FOOTER //
// ./factories/system_configuration_factory.js